import React, { PureComponent } from 'react'
import Navbar from '../NavBar/NavBar'
import '../../StylesPages/coaching.css'

export class Coaching extends PureComponent {
    render() {
        return (
            <div className="coaching-container">
                <Navbar />
                <h1>Coaching</h1>
            </div>
        )
    }
}

export default Coaching
